import type { PopulateFormResponse, TaxonomyResponse } from "@/services/craftService";
import type { TemplateResponse } from "@/services/templateService";
import type { CraftData, CraftTaxonomy, CraftTemplate } from "@/stores/craftStore";

export const normalizePopulateForm = (response: PopulateFormResponse): Omit<CraftData, "taxonomies" | "templates"> => {
    return {
        actions: response?.flow_steps?.step_1_actions?.map((action) => ({
            id: action.id,
            name: action.name,
            description: action.description,
        })) || [],
        formats: response?.flow_steps?.step_2_formats?.map((format) => ({
            id: format.format_type,
            name: format.name,
            description: format.description,
        })) || [],
    };
};

export const normalizeTemplates = (response: TemplateResponse): CraftTemplate[] => {
    return response.results?.map((template) => ({
        id: `${template.id}`,
        image: template.data.image,
        name: template.data.name,
    })) || [];
};

export const normalizeTaxonomies = (response: TaxonomyResponse): CraftTaxonomy[] => {
    return response.taxonomies?.map((taxonomy) => ({
        id: `${taxonomy.id}`,
        name: taxonomy.display_name,
        format_type: taxonomy.format_type,
        layout: taxonomy.visual_preview.description,
        preview_image_url: taxonomy.visual_preview.preview_image_url,
        specifications: taxonomy.specifications || {},
    })) || [];
};